import type { TranslationKeys } from "../../i18n/types";
import { type DisciplinaryViolation, DisciplinaryViolationType, MissingPunchSide } from "../../utils/models";

export const VIOLATION_TYPE_LABEL_KEYS = {
	[DisciplinaryViolationType.NCNS]: "disciplinary.violation.ncns",
	[DisciplinaryViolationType.CallIn]: "disciplinary.violation.call_in",
	[DisciplinaryViolationType.LateArrival]: "disciplinary.violation.late_arrival",
	[DisciplinaryViolationType.HomeEarly]: "disciplinary.violation.home_early",
	[DisciplinaryViolationType.ShiftDelta]: "disciplinary.violation.shift_delta",
	[DisciplinaryViolationType.SkippedLunch]: "disciplinary.violation.skipped_lunch",
	[DisciplinaryViolationType.MissingPunch]: "disciplinary.violation.missing_punch",
} as const satisfies Record<DisciplinaryViolationType, TranslationKeys>;

const MISSING_PUNCH_SIDE_LABEL_KEYS = {
	[MissingPunchSide.In]: "disciplinary.violation.missing_punch_in",
	[MissingPunchSide.Out]: "disciplinary.violation.missing_punch_out",
} as const satisfies Record<MissingPunchSide, TranslationKeys>;

type LabelledViolation = Pick<DisciplinaryViolation, "violationType" | "missingPunchSide">;

/**
 * Missing punch is a single type for points, rules, filtering and the summary card — only the
 * per-shift row names which half of the pair is absent.
 */
export const violationLabelKey = (violation: LabelledViolation): TranslationKeys =>
	violation.violationType === DisciplinaryViolationType.MissingPunch && violation.missingPunchSide
		? MISSING_PUNCH_SIDE_LABEL_KEYS[violation.missingPunchSide]
		: VIOLATION_TYPE_LABEL_KEYS[violation.violationType];

/**
 * Scheduled hours the missing punch left untracked — the whole shift, since neither the in nor the
 * out punch can bound it. Mirrors missing_punch_hours in backend/services/disciplinary_export.py so
 * the summary card and the export agree.
 */
export const missingPunchHours = (violation: DisciplinaryViolation): number =>
	violation.violationType === DisciplinaryViolationType.MissingPunch ? violation.plannedEnd.diff(violation.plannedStart, "hours").hours : 0;
